import Icon from '../components/Icon';

const CollTrailWheelchair = Icon(
  'coll-trail-wheelchair',
  <>
    <path d="M12.838 5.563q.847 0 1.467.322.618.323 1.326 1.03 1.945 2.027 3.517 2.78a7.9 7.9 0 0 0 2.234.674c.743.113 1.347.718 1.339 1.47-.009.747-.62 1.357-1.36 1.258a11.4 11.4 0 0 1-2.438-.617q-1.91-.705-3.288-1.689l.031 3.99 3.352.067q1.166 0 1.997.722.83.722.83 1.737V24h-2.947v-6.08l-6.06-.066q-1.166 0-1.997-.722t-.831-1.737V8.022q0-1.014.83-1.737.832-.721 1.998-.721" />
    <path d="M8.546 11.716a4.61 4.61 0 1 0 3.64 7.895h3.735A7.694 7.694 0 1 1 8.546 8.625zM12.908 0q.99 0 1.696.705.705.705.705 1.695t-.705 1.695-1.696.705q-.99 0-1.695-.705a2.3 2.3 0 0 1-.704-1.695q0-.99.704-1.695A2.31 2.31 0 0 1 12.908 0" />
  </>
);

export default CollTrailWheelchair;
